import React, { useState } from "react";
import { SuccussIcon } from "../../../styles/img/svg/SuccussIcon";
import { UiButton, UiGradiantOutlinedBtn } from "../common/UiButton";
import { UiHorizontalButtonGroup } from "../common/UiHorizontalButtonGroup";
import { useTranslation } from "react-i18next";

export const ConfirmationPopup = (props) => {
  const { t, i18n } = useTranslation();

  const [onClickName, setOnClickName] = useState(
    props?.buttonOnClickName ? props?.buttonOnClickName : t("Save"),
  );
  return (
    <>
      <div
        className={
          props?.className ? props?.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props?.message}
        </h3>
        {props?.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            className="df-red-gradiant-outlined-btn"
            onClick={props?.buttonOnClickClose}
            name={
              props?.buttonOnClickCloseName
                ? props?.buttonOnClickCloseName
                : t("Cancel")
            }
          />
          <UiButton
            onClick={props?.buttonOnClick}
            className="df-ui-dark-bg-btn"
            name={onClickName}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};

export const LeaveConfirmationPopup = (props) => {
  const { t, i18n } = useTranslation();

  let onClickBtnText = props?.successBtnText
    ? props?.successBtnText
    : t("Leave");
  return (
    <>
      <div
        className={
          props?.className ? props?.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props?.message}
        </h3>
        {props?.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            className="df-red-gradiant-outlined-btn"
            name={t("Cancel")}
            onClick={props?.buttonOnClickClose}
          />
          <UiButton
            className="df-ui-dark-bg-btn"
            name={onClickBtnText}
            onClick={props?.buttonOnClick}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};

export const ConfirmationPopupWithCustomButton = (props) => {
  return (
    <>
      <div
        className={
          props.className ? props.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props?.message}
        </h3>
        {props?.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            className="df-red-gradiant-outlined-btn"
            name={props?.CancelButtonName}
            onClick={props?.buttonOnClickClose}
          />
          <UiButton
            className="df-ui-dark-bg-btn"
            name={props?.SuccessButtonName}
            onClick={props?.buttonOnClick}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};
